import type { ReactNode } from 'react';
import { Menu } from '@kula-ai/components';
import type { WorkdayHireType } from './hireType';
import { WORKDAY_HIRE_TYPES } from './hireType';

export interface WorkdayHireMenuProps {
  /**
   * The button that opens it.
   *
   * Supplied by the caller rather than built here: the three surfaces that
   * offer this each use a different button — the hired-stage card `KButton`,
   * the modal Chakra's — and a trigger of its own would sit beside neighbours
   * it does not match in size, colour or alignment.
   */
  trigger: ReactNode;
  onSelect: (_hireType: WorkdayHireType) => void;
}

/**
 * Every Workday hire type, behind one control.
 *
 * One menu rather than two buttons: the recruiter is picking *how* to do one
 * action, not choosing between two, and it matches the "Add to HRIS" menu they
 * already use.
 */
export const WorkdayHireMenu = ({
  trigger,
  onSelect,
}: WorkdayHireMenuProps) => (
  <Menu
    align="end"
    trigger={trigger}
    items={WORKDAY_HIRE_TYPES.map(({ value, label }) => ({
      key: value,
      label,
      onClick: () => onSelect(value),
    }))}
  />
);

export default WorkdayHireMenu;
